// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-ExternalInvest-components-___CheckOption__main___mRW5y","mainAlt":"src-components-ExternalInvest-components-___CheckOption__mainAlt___h0Ue4","checkBox":"src-components-ExternalInvest-components-___CheckOption__checkBox___EH1Cq","textBlock":"src-components-ExternalInvest-components-___CheckOption__textBlock___TNH6I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalInvest/components/CheckOption.css
// module id = 1239
// module chunks = 3